import { Element, Node } from "@siteimprove/alfa-dom";
import { Style } from "../../style.js";
const { isElement } = Element;
/**
 * @public
 */
export function hasComputedStyle(name, predicate, device, context) {
    return function hasComputedStyle(node) {
        return isElement(node)
            ? Style.from(node, device, context).computed(name).some(predicate)
            : node.parent(Node.flatTree).filter(isElement).some(hasComputedStyle);
    };
}
//# sourceMappingURL=has-computed-style.js.map